<div class="toast toast-{{ data.type }}"
     [@fadeAnimation]="{value: animationState, params:
        { fadeIn: toastConfig.animation.fadeIn, fadeOut: toastConfig.animation.fadeOut }}"
     (@fadeAnimation.done)="onFadeFinished($event)">
  <div class="toast-wrap">
    <div class="toast-text">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20" class="toast-icon" *ngIf="data.type === 'success'">
        <defs>
          <path id="a" d="M4.571 10.867L.495 6.791l1.01-1.01 3.066 3.066L12.638.781l1.01 1.01z"/>
        </defs>
        <use fill="#FFF" fill-rule="evenodd" transform="translate(4 3)" xlink:href="#a"/>
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20" class="toast-icon"  *ngIf="data.type === 'error'">
        <defs>
          <path id="a" d="M10 .714l10 18.572H0L10 .714zm0 3.014l-7.608 14.13h15.216L10 3.727zM10.714 15v1.429H9.286V15h1.428zm0-7.143v5.714H9.286V7.857h1.428z"/>
        </defs>
        <use fill="#FFF" fill-rule="evenodd" xlink:href="#a"/>
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20" class="toast-icon" *ngIf="data.type === 'info'">
        <defs>
          <path id="a" d="M10 0c5.514 0 10 4.486 10 10s-4.486 10-10 10S0 15.514 0 10 4.486 0 10 0zm0 1.429c-4.726 0-8.571 3.845-8.571 8.571 0 4.726 3.845 8.571 8.571 8.571 4.726 0 8.571-3.845 8.571-8.571 0-4.726-3.845-8.571-8.571-8.571zm.714 6.428V15H9.286V7.857h1.428zm0-2.857v1.429H9.286V5h1.428z"/>
        </defs>
        <use fill="#FFF" fill-rule="evenodd" xlink:href="#a"/>
      </svg>
      <span class="toast-message">{{ data.text }}</span>
    </div>
    <span class="toast-actions"><!-- no actions --></span>
    <span class="btn-toast" *ngIf="data?.btn?.display" (click)="goToRoute()">{{ data?.btn?.text }}</span>
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" (click)="close()" class="toast-close">
      <path fill="#FFF" fill-rule="evenodd" d="M14.933 6.076l-1.01-1.01L10 8.99 6.077 5.066l-1.01 1.01L8.99 10l-3.923 3.924 1.01 1.01L10 11.01l3.923 3.924 1.01-1.01L11.01 10z"/>
    </svg>
  </div>
</div>
